import React from 'react'
import { UnknownQuestionType } from '../types'
import { unansweredQuestionTypeLabels } from '../configs'

import { useUnknownQuestions } from '../context'
import { TypeButtonGroup, TypeOption } from './styles'

export const QuestionTypeButtonGroup = () => {
  const options: UnknownQuestionType[] = Object.values(UnknownQuestionType)
  const { removeFilter, addFilterParam, filter } = useUnknownQuestions()

  const onTypeChange = (buttonType: UnknownQuestionType) => {
    if (filter?.type === buttonType) {
      removeFilter('type')
    } else {
      addFilterParam('type', buttonType)
    }
  }

  return (
    <TypeButtonGroup>
      {options.map(option => (
        <TypeOption key={option} onClick={() => onTypeChange(option)} isActive={filter?.type === option}>
          {unansweredQuestionTypeLabels[option]}
        </TypeOption>
      ))}
    </TypeButtonGroup>
  )
}
